(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var CLAVE_ALMACENAMIENTO = 'lph_publico_seleccionado';

  var secciones = document.querySelectorAll('.hero-problema');
  secciones.forEach(function(seccion) {
    var botones = seccion.querySelectorAll('[data-hero-boton]');
    var contenidos = seccion.querySelectorAll('[data-hero-contenido]');

    var publicoActual = null;
    var animando = false;

    function guardarEleccion(publico) {
      try {
        sessionStorage.setItem(CLAVE_ALMACENAMIENTO, publico);
      } catch (error) {
        return;
      }
    }

    function leerEleccionGuardada() {
      try {
        return sessionStorage.getItem(CLAVE_ALMACENAMIENTO);
      } catch (error) {
        return null;
      }
    }

    function pintarBotones(publico) {
      botones.forEach(function(boton) {
        var esActivo = boton.getAttribute('data-hero-boton') === publico;
        boton.setAttribute('aria-pressed', esActivo ? 'true' : 'false');
        if (esActivo) {
          boton.style.backgroundColor = boton.getAttribute('data-color-activo-fondo');
          boton.style.color = boton.getAttribute('data-color-activo-texto');
        } else {
          boton.style.backgroundColor = boton.getAttribute('data-color-inactivo-fondo');
          boton.style.color = boton.getAttribute('data-color-inactivo-texto');
        }
      });
    }

    function mostrarContenido(publico) {
      contenidos.forEach(function(contenido) {
        if (contenido.getAttribute('data-hero-contenido') !== publico) return;
        contenido.classList.add('hero-problema__contenido-activo');
        contenido.offsetHeight;
        requestAnimationFrame(function() {
          contenido.classList.add('hero-problema__contenido-visible');
        });
      });
    }

    function ocultarContenido(publico, alTerminar) {
      var contenidoSaliente = null;
      contenidos.forEach(function(contenido) {
        if (contenido.getAttribute('data-hero-contenido') === publico) {
          contenidoSaliente = contenido;
        }
      });
      if (!contenidoSaliente) {
        if (alTerminar) alTerminar();
        return;
      }
      contenidoSaliente.classList.remove('hero-problema__contenido-visible');
      setTimeout(function() {
        contenidoSaliente.classList.remove('hero-problema__contenido-activo');
        if (alTerminar) alTerminar();
      }, 320);
    }

    function activarPublico(publico, guardar) {
      if (publico === publicoActual || animando) return;
      animando = true;
      pintarBotones(publico);
      if (guardar) {
        guardarEleccion(publico);
      }
      var anterior = publicoActual;
      publicoActual = publico;
      if (anterior) {
        ocultarContenido(anterior, function() {
          mostrarContenido(publico);
          animando = false;
        });
      } else {
        mostrarContenido(publico);
        animando = false;
      }
    }

    botones.forEach(function(boton) {
      boton.setAttribute('type', 'button');
      boton.setAttribute('aria-pressed', 'false');
      boton.addEventListener('click', function() {
        activarPublico(boton.getAttribute('data-hero-boton'), true);
      });
    });

    var publicoGuardado = leerEleccionGuardada();
    var activoInicial = seccion.querySelector('.hero-problema__contenido-activo');
    var publicoInicial = activoInicial ? activoInicial.getAttribute('data-hero-contenido') : null;

    if (publicoGuardado === 'estudiante' || publicoGuardado === 'docente') {
      publicoInicial = publicoGuardado;
    }

    if (publicoInicial) {
      contenidos.forEach(function(contenido) {
        if (contenido.getAttribute('data-hero-contenido') === publicoInicial) {
          contenido.classList.add('hero-problema__contenido-activo');
        } else {
          contenido.classList.remove('hero-problema__contenido-activo');
        }
      });
      publicoActual = publicoInicial;
      pintarBotones(publicoInicial);
      var contenidoInicial = seccion.querySelector('[data-hero-contenido="' + publicoInicial + '"]');
      if (contenidoInicial) {
        contenidoInicial.classList.add('hero-problema__contenido-visible');
      }
    }

    var botonScroll = seccion.querySelector('[data-hero-scroll]');
    if (botonScroll) {
      botonScroll.addEventListener('click', function(e) {
        var destino = document.getElementById('seccion-packs');
        if (destino) {
          e.preventDefault();
          destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-social"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.barra-social');
  secciones.forEach(function(seccion) {
    var mediaReducido = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pista = seccion.querySelector('[data-barra-pista]');
    if (!pista) return;
    if (mediaReducido.matches) {
      pista.style.animationPlayState = 'paused';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var CLAVE_ALMACENAMIENTO = 'lph_publico_seleccionado';

  function leerEleccionGuardada() {
    try {
      return sessionStorage.getItem(CLAVE_ALMACENAMIENTO);
    } catch (error) {
      return null;
    }
  }

  function guardarEleccion(publico) {
    try {
      sessionStorage.setItem(CLAVE_ALMACENAMIENTO, publico);
    } catch (error) {
      return;
    }
  }

  var secciones = document.querySelectorAll('.precios-packs');
  secciones.forEach(function(seccion) {
    var botones = seccion.querySelectorAll('[data-packs-boton]');
    var contenidos = seccion.querySelectorAll('[data-packs-contenido]');

    var publicoActual = null;
    var animando = false;

    function pintarBotones(publico) {
      botones.forEach(function(boton) {
        var esActivo = boton.getAttribute('data-packs-boton') === publico;
        boton.setAttribute('aria-pressed', esActivo ? 'true' : 'false');
        if (esActivo) {
          boton.style.backgroundColor = boton.getAttribute('data-color-activo-fondo');
          boton.style.color = boton.getAttribute('data-color-activo-texto');
        } else {
          boton.style.backgroundColor = boton.getAttribute('data-color-inactivo-fondo');
          boton.style.color = boton.getAttribute('data-color-inactivo-texto');
        }
      });
    }

    function mostrarContenido(publico) {
      contenidos.forEach(function(contenido) {
        if (contenido.getAttribute('data-packs-contenido') !== publico) return;
        contenido.classList.add('precios-packs__contenido-activo');
        contenido.offsetHeight;
        requestAnimationFrame(function() {
          contenido.classList.add('precios-packs__contenido-visible');
        });
      });
    }

    function ocultarContenido(publico, alTerminar) {
      var saliente = null;
      contenidos.forEach(function(contenido) {
        if (contenido.getAttribute('data-packs-contenido') === publico) {
          saliente = contenido;
        }
      });
      if (!saliente) {
        if (alTerminar) alTerminar();
        return;
      }
      saliente.classList.remove('precios-packs__contenido-visible');
      setTimeout(function() {
        saliente.classList.remove('precios-packs__contenido-activo');
        if (alTerminar) alTerminar();
      }, 320);
    }

    function activarPublico(publico, guardar) {
      if (publico === publicoActual || animando) return;
      animando = true;
      pintarBotones(publico);
      if (guardar) {
        guardarEleccion(publico);
      }
      var anterior = publicoActual;
      publicoActual = publico;
      if (anterior) {
        ocultarContenido(anterior, function() {
          mostrarContenido(publico);
          animando = false;
        });
      } else {
        mostrarContenido(publico);
        animando = false;
      }
    }

    botones.forEach(function(boton) {
      boton.setAttribute('type', 'button');
      boton.setAttribute('aria-pressed', 'false');
      boton.addEventListener('click', function() {
        activarPublico(boton.getAttribute('data-packs-boton'), true);
      });
    });

    var publicoGuardado = leerEleccionGuardada();
    var activoInicial = seccion.querySelector('.precios-packs__contenido-activo');
    var publicoInicial = activoInicial ? activoInicial.getAttribute('data-packs-contenido') : null;

    if (publicoGuardado === 'estudiante' || publicoGuardado === 'docente') {
      publicoInicial = publicoGuardado;
    }

    if (publicoInicial) {
      contenidos.forEach(function(contenido) {
        if (contenido.getAttribute('data-packs-contenido') === publicoInicial) {
          contenido.classList.add('precios-packs__contenido-activo');
        } else {
          contenido.classList.remove('precios-packs__contenido-activo');
        }
      });
      publicoActual = publicoInicial;
      pintarBotones(publicoInicial);
      var contenidoInicial = seccion.querySelector('[data-packs-contenido="' + publicoInicial + '"]');
      if (contenidoInicial) {
        contenidoInicial.classList.add('precios-packs__contenido-visible');
      }
    }
  });
})();

class ProductFormPack extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('[data-pack-form]');
    this.boton = this.form ? this.form.querySelector('button[type="submit"]') : null;
    this.spanTexto = this.boton ? this.boton.querySelector('.precios-packs__boton-texto') : null;
    this.textoOriginal = this.spanTexto ? this.spanTexto.textContent.trim() : '';

    if (this.form) {
      this.form.addEventListener('submit', this.agregarAlCarrito.bind(this));
    }
  }

  agregarAlCarrito(evento) {
    evento.preventDefault();

    if (!this.boton || this.boton.disabled) {
      return;
    }

    var formData = new FormData(this.form);
    var cuerpo = JSON.stringify({
      id: formData.get('id'),
      quantity: 1
    });

    this.establecerEstado('cargando');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: cuerpo
    })
      .then(function (respuesta) {
        return respuesta.json().then(function (datos) {
          if (!respuesta.ok) {
            throw new Error(datos.description || 'No se pudo agregar el producto');
          }
          return datos;
        });
      })
      .then(this.alAgregarConExito.bind(this))
      .catch(this.alFallarAgregado.bind(this));
  }

  alAgregarConExito() {
    this.establecerEstado('exito');
    this.actualizarYAbrirCarrito();
  }

  actualizarYAbrirCarrito() {
    var cartDrawerEl = document.querySelector('cart-drawer');

    if (!cartDrawerEl) {
      window.location.href = '/cart';
      return;
    }

    var contenedorSeccion = cartDrawerEl.closest('[id^="shopify-section-"]');

    if (!contenedorSeccion) {
      window.location.href = '/cart';
      return;
    }

    var idSeccion = contenedorSeccion.id.replace('shopify-section-', '');

    fetch('/?sections=' + encodeURIComponent(idSeccion))
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (datos) {
        var html = datos[idSeccion];

        if (!html) {
          window.location.href = '/cart';
          return;
        }

        var parser = new DOMParser();
        var docNuevo = parser.parseFromString(html, 'text/html');

        var innerNuevo = docNuevo.querySelector('.drawer__inner');
        var innerActual = cartDrawerEl.querySelector('.drawer__inner');

        if (innerNuevo && innerActual) {
          innerActual.innerHTML = innerNuevo.innerHTML;
        }

        cartDrawerEl.classList.remove('is-empty');

        if (typeof cartDrawerEl.open === 'function') {
          cartDrawerEl.open();
        } else {
          cartDrawerEl.classList.add('active');
        }
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  alFallarAgregado(error) {
    this.establecerEstado('error');
    console.error(error);

    var self = this;
    setTimeout(function () {
      self.establecerEstado('normal');
    }, 2500);
  }

  establecerEstado(estado) {
    if (!this.boton || !this.spanTexto) {
      return;
    }

    if (estado === 'cargando') {
      this.boton.disabled = true;
      this.spanTexto.textContent = 'Agregando...';
    } else if (estado === 'exito') {
      this.boton.disabled = false;
      this.spanTexto.textContent = '✓ Agregado';
    } else if (estado === 'error') {
      this.boton.disabled = false;
      this.spanTexto.textContent = 'Reintentar';
    } else {
      this.boton.disabled = false;
      this.spanTexto.textContent = this.textoOriginal;
    }
  }
}

if (!customElements.get('product-form-pack')) {
  customElements.define('product-form-pack', ProductFormPack);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["publicos"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.spub-seccion');
  secciones.forEach(function(seccion) {
    var botones = seccion.querySelectorAll('[data-spub-boton]');
    var contenidos = seccion.querySelectorAll('[data-spub-contenido]');

    function activarPublico(publico) {
      botones.forEach(function(boton) {
        if (boton.getAttribute('data-spub-boton') === publico) {
          boton.classList.add('spub-boton-activo');
        } else {
          boton.classList.remove('spub-boton-activo');
        }
      });
      contenidos.forEach(function(contenido) {
        if (contenido.getAttribute('data-spub-contenido') === publico) {
          contenido.classList.add('spub-contenido-activo');
        } else {
          contenido.classList.remove('spub-contenido-activo');
        }
      });
    }

    botones.forEach(function(boton) {
      boton.addEventListener('click', function() {
        activarPublico(boton.getAttribute('data-spub-boton'));
      });
    });

    var activoInicial = seccion.querySelector('.spub-contenido-activo');
    if (activoInicial) {
      activarPublico(activoInicial.getAttribute('data-spub-contenido'));
    }

    var botonesAgregar = seccion.querySelectorAll('[data-spub-agregar]');
    botonesAgregar.forEach(function(boton) {
      boton.addEventListener('click', function() {
        var variantId = boton.getAttribute('data-variant-id');
        if (!variantId) return;
        boton.disabled = true;
        var textoOriginal = boton.textContent;
        boton.textContent = 'Agregando...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function(respuesta) {
            if (!respuesta.ok) throw new Error('error al agregar');
            return respuesta.json();
          })
          .then(function() {
            boton.textContent = 'Agregado';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function() {
              boton.textContent = textoOriginal;
              boton.disabled = false;
            }, 1500);
          })
          .catch(function() {
            boton.textContent = 'Error, reintentar';
            boton.disabled = false;
          });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vistaprevia"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.vpe-seccion').forEach(function (seccion) {
    var contenedorId = seccion.id;
    var lightbox = document.getElementById('vpe-lightbox-' + contenedorId.replace('vpe-', ''));
    var tabs = seccion.querySelectorAll('.vpe-tab');
    var slides = Array.prototype.slice.call(seccion.querySelectorAll('.vpe-slide'));
    var puntosContenedor = seccion.querySelector('.vpe-puntos');
    var flechaIzq = seccion.querySelector('.vpe-flecha-izq');
    var flechaDer = seccion.querySelector('.vpe-flecha-der');
    var nivelActivo = 'portada';
    var indiceActivo = 0;

    function slidesDelNivel(nivel) {
      return slides.filter(function (s) { return s.getAttribute('data-nivel') === nivel; });
    }

    function renderizarPuntos(lista) {
      puntosContenedor.innerHTML = '';
      if (lista.length <= 1) return;
      lista.forEach(function (_, i) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'vpe-punto' + (i === indiceActivo ? ' vpe-activo' : '');
        punto.addEventListener('click', function () {
          indiceActivo = i;
          mostrarSlide();
        });
        puntosContenedor.appendChild(punto);
      });
    }

    function mostrarSlide() {
      slides.forEach(function (s) { s.classList.remove('vpe-slide-visible'); });
      var lista = slidesDelNivel(nivelActivo);
      if (!lista.length) return;
      if (indiceActivo >= lista.length) indiceActivo = 0;
      if (indiceActivo < 0) indiceActivo = lista.length - 1;
      lista[indiceActivo].classList.add('vpe-slide-visible');
      renderizarPuntos(lista);
      if (flechaIzq) flechaIzq.classList.toggle('vpe-oculto', lista.length <= 1);
      if (flechaDer) flechaDer.classList.toggle('vpe-oculto', lista.length <= 1);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('vpe-activo'); });
        tab.classList.add('vpe-activo');
        nivelActivo = tab.getAttribute('data-nivel');
        indiceActivo = 0;
        mostrarSlide();
      });
    });

    if (flechaIzq) {
      flechaIzq.addEventListener('click', function () {
        indiceActivo -= 1;
        mostrarSlide();
      });
    }

    if (flechaDer) {
      flechaDer.addEventListener('click', function () {
        indiceActivo += 1;
        mostrarSlide();
      });
    }

    seccion.querySelectorAll('.vpe-marco').forEach(function (marco) {
      marco.addEventListener('click', function () {
        if (!lightbox) return;
        var img = marco.querySelector('.vpe-imagen');
        if (!img) return;
        var imgLightbox = lightbox.querySelector('.vpe-lightbox-imagen');
        imgLightbox.src = img.src;
        imgLightbox.alt = img.alt;
        lightbox.classList.add('vpe-lightbox-abierto');
        lightbox.setAttribute('aria-hidden', 'false');
      });
    });

    if (lightbox) {
      var cerrar = lightbox.querySelector('.vpe-lightbox-cerrar');
      var lbIzq = lightbox.querySelector('.vpe-lightbox-izq');
      var lbDer = lightbox.querySelector('.vpe-lightbox-der');

      function cerrarLightbox() {
        lightbox.classList.remove('vpe-lightbox-abierto');
        lightbox.setAttribute('aria-hidden', 'true');
      }

      function actualizarLightboxImagen() {
        var lista = slidesDelNivel(nivelActivo);
        var img = lista[indiceActivo] ? lista[indiceActivo].querySelector('.vpe-imagen') : null;
        if (img) lightbox.querySelector('.vpe-lightbox-imagen').src = img.src;
      }

      if (cerrar) cerrar.addEventListener('click', cerrarLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) cerrarLightbox();
      });

      if (lbIzq) {
        lbIzq.addEventListener('click', function () {
          indiceActivo -= 1;
          mostrarSlide();
          actualizarLightboxImagen();
        });
      }

      if (lbDer) {
        lbDer.addEventListener('click', function () {
          indiceActivo += 1;
          mostrarSlide();
          actualizarLightboxImagen();
        });
      }
    }

    mostrarSlide();
  });
});

  } catch(e) { console.error(e); }
})();
})();
